module.exports = __webpack_public_path__ + "img/KSC09398.565d28e3.jpg";